// common/services/deletePrivateToDo.js  (DELETE)
import { isLoaded, isLoading } from "../actions";
import Alert from "../../../Common/Alert";
import API from "../../../Common/Network/API";

export async function deletePrivateToDo(state, dispatch, getUser, pt_id, handleClose,SUBTASK_DELETE) {
  dispatch(isLoading());
    try {
      var response = await API.post("private_todo.php", {
        action: "delete",
        pt_id: pt_id,
      }, {}, false);
      if (response.status === 'True') {
        Alert("success", SUBTASK_DELETE);
      }
    } catch (error) {
      Alert('error', error.message);
      dispatch(isLoaded());
    }
    handleClose()
} 